<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    dense
                    :label="$t('name')"
                    v-model="form.name"
                    outlined
                    hide-details
                    :rules="[isRequired]"
                    >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    dense
                    :label="$t('user')"
                    v-model="form.user_id"
                    outlined
                    hide-details
                    :items="users"
                    :loading="usersLoading"
                    item-text="full_name"
                    item-value="id"
                    @update:search-input="searchUsers"
                    clearable
                ></v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from './../../utils/validations';
import user from './../../services/sales/user';

export default {
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                name: null,
                user_id: null
            },
            users: [],
            usersLoading: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    methods: {
        isRequired,
        searchUsers(query) {
            this.usersLoading = true;
            user.search(query).then(res => {
                this.users = [...this.users, ...res.data];
            }).finally(() => {
                this.usersLoading = false;
            })
        }
    },
    created() {
        this.form = {...this.value}
    }
}
</script>

<style>

</style>